import { useCallback, useRef } from "react";
import { prefetchChunkMap } from "../pages/(v1)/router.v1";

// route path(또는 그 하위 경로/해시)에서 가장 길게 매칭되는 청크 키를 찾는다.
// 예: "/cyber-relation/new-article/1" → "/cyber-relation/new-article"
function findChunkKey(url) {
  if (!url || url.startsWith("http")) return null;
  const path = url.split("#")[0]; // 해시 제거
  return Object.keys(prefetchChunkMap)
    .filter((key) => path === key || path.startsWith(key + "/"))
    .sort((a, b) => b.length - a.length)[0] ?? null;
}

const usePrefetch = () => {
  const prefetched = useRef(new Set());

  const prefetch = useCallback((url) => {
    const key = findChunkKey(url);
    if (!key || prefetched.current.has(key)) return;
    prefetched.current.add(key);
    prefetchChunkMap[key]();
  }, []);

  return prefetch;
};

export default usePrefetch;
